import { render } from "./TermoUso.vue?vue&type=template&id=42f5d5c5&scoped=true"
import script from "./TermoUso.vue?vue&type=script&lang=js"
export * from "./TermoUso.vue?vue&type=script&lang=js"

import "./TermoUso.vue?vue&type=style&index=0&id=42f5d5c5&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f5d5c5"]])

export default __exports__